import http from '@/api/http'
import { rulesPageLimit } from '@/config/api'
import { cursorParams, type PageMeta } from '@/api/pagination'

export interface Rule {
  // One row from GET `/rules` (cursor-paginated list).

  id: number
  // Rule id.

  name: string
  // Internal rule slug (e.g. `bachata_discount_rule_2025`).

  rule_text: string
  // Human-readable description of the rule, pre-rendered by the backend.

  start_time: string | null
  // Optional ISO 8601 datetime when the rule becomes effective.

  end_time: string | null
  // Optional ISO 8601 datetime when the rule stops applying; `null` means open-ended.
}

interface RulesResponse extends PageMeta {
  // Paginated list payload from GET `/rules`.

  items: Rule[]
  // Page of rules.
}

/**
 * Fetches a page of rules. Same cursor/limit contract as `fetchClients`.
 * @param cursor - Optional; pass `next_cursor` from a previous page for the next page.
 */
export async function fetchRules(cursor?: number): Promise<RulesResponse> {
  const { data } = await http.get<RulesResponse>('/rules', {
    params: cursorParams(rulesPageLimit, cursor),
  })
  if (import.meta.env.DEV) {
    console.log('[fetchRules] GET /rules response', data)
  }
  return data
}
